interface Props {
  color?: string
  width?: number
  height?: number
}

export const ArrowIcon = ({ color = '#6F6F6F', width = 20, height = 14 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8115 0.146362C13.0067 -0.0488341 13.3233 -0.0487028 13.5186 0.146362L19.8516 6.47839C20.0468 6.67366 20.0468 6.99114 19.8516 7.1864L13.5186 13.5184C13.3233 13.7136 13.0068 13.7137 12.8115 13.5184C12.6165 13.3232 12.6164 13.0066 12.8115 12.8114L18.2881 7.33289H0.5C0.224111 7.33275 0.000222601 7.10875 0 6.83289C0 6.55683 0.223974 6.33302 0.5 6.33289H18.29L12.8115 0.853394C12.6165 0.658147 12.6164 0.341566 12.8115 0.146362Z"
        fill={color}
      />
    </svg>
  )
}
